/** Calendar-day difference from today to expiry (positive = future). */
export const daysUntilLicenseExpiry = (value) => {
  if (value == null || value === "") return null;
  const s = String(value).trim();
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  let exp;
  if (iso) {
    exp = new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
  } else {
    const parsed = new Date(s);
    if (Number.isNaN(parsed.getTime())) return null;
    exp = new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
  }
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((exp - today) / 86400000);
};

const trExpiryFromRaw = (raw) =>
  raw?.license_expiry_date ??
  raw?.licence_expiry_date ??
  raw?.license_expiry ??
  raw?.licence_expiry ??
  raw?.expiry ??
  null;

const ntExpiryFromRaw = (raw) =>
  raw?.nt_license_expiry_date ??
  raw?.nt_licence_expiry_date ??
  raw?.nt_license_expiry ??
  raw?.nt_licence_expiry ??
  null;

/**
 * Accountant may edit driver license details when renewal is due:
 * - API marks license as expired, or
 * - TR or NT expiry is today, tomorrow, or already past.
 * (e.g. today 21 Sep → expiry 22 Sep allowed; 23 Sep not allowed.)
 */
export const canAccountantEditDriverLicense = (raw) => {
  if (!raw || typeof raw !== "object") return false;

  if (raw.license_expire === true || raw.license_expire === 1 || raw.license_expire === "1") {
    return true;
  }

  const checkDate = (dateVal) => {
    const days = daysUntilLicenseExpiry(dateVal);
    if (days == null) return false;
    if (days < 0) return true;
    if (days === 0 || days === 1) return true;
    return false;
  };

  if (checkDate(trExpiryFromRaw(raw))) return true;
  if (checkDate(ntExpiryFromRaw(raw))) return true;
  return false;
};
